import * as Accordion from '@radix-ui/react-accordion';
import { motion } from 'framer-motion';

import { Icon } from '@/components/icon';
import { accordionChevronIconVariants, navItemVariants } from '@/components/modules/app-navigation/utils/transitions';
import { tv } from '@/utils/styles';

export interface OpenSectionHeaderProps {
  label: string;
  isOpen?: boolean;
  visibility: 'visible' | 'hidden';
}

const OpenSectionHeader = ({ visibility, label, isOpen }: OpenSectionHeaderProps) => {
  const { base, trigger, triggerLabel, triggerIcon } = styles({ isOpen });

  return (
    <Accordion.Header className={base()}>
      <Accordion.Trigger className={trigger()}>
        <motion.span variants={navItemVariants} animate={visibility} initial={visibility}>
          <span className={triggerLabel()}>{label}</span>
        </motion.span>
        <motion.span variants={accordionChevronIconVariants} animate={visibility} className={triggerIcon()}>
          <Icon name="down-solid" size="3" color="lightBlue.800" />
        </motion.span>
      </Accordion.Trigger>
    </Accordion.Header>
  );
};

const styles = tv({
  slots: {
    base: 'mb-1 pl-2 text-sm',
    trigger: 'flex items-center',
    triggerLabel: 'mr-1 uppercase text-lightBlue-600',
    triggerIcon: 'shrink-0 transition-all duration-200',
  },
  variants: {
    isOpen: {
      true: {},
      false: {
        triggerIcon: 'rotate-180',
      },
    },
  },
});

export { OpenSectionHeader };
